import { Badge } from "../ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";
import { getSystemIconPath } from "../../lib/systemOfRecord";
import { OptroLink } from "../../models/audit/optroLink";

interface OptroLinkPillProps {
  link: OptroLink;
}

// The URL is built from a workspace's configured Optro base URL, which nothing
// holds to a web scheme.
function isWebUrl(url: string): boolean {
  try {
    const { protocol } = new URL(url);
    return protocol === "http:" || protocol === "https:";
  } catch {
    return false;
  }
}

// Opens the session's linked Optro record in a new tab. Rendered only when the
// session envelope carries a resolved link.
export function OptroLinkPill({ link }: OptroLinkPillProps) {
  if (!isWebUrl(link.url)) return null;

  const reference =
    link.targetType === "Test"
      ? `test ${link.targetId}`
      : `WS#${link.targetId}`;

  return (
    <Tooltip>
      {/* The trigger must be a native element. Badge does not forward refs, so
          Radix cannot anchor to it and positions the content off-screen. */}
      <TooltipTrigger asChild>
        <a
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex"
        >
          <Badge
            variant="outline"
            className="gap-1.5 whitespace-nowrap bg-white cursor-pointer"
          >
            Optro Link
            <img
              src={getSystemIconPath("auditboard")}
              alt=""
              className="h-3.5 w-3.5 shrink-0"
            />
          </Badge>
        </a>
      </TooltipTrigger>
      <TooltipContent>Open in Optro ({reference})</TooltipContent>
    </Tooltip>
  );
}
